export default __webpack_public_path__ + "static/media/3.8c3516d2.jpg";